import { useMemo } from "react";

export type ButtonTheme = "primary" | "secondary" | "disabled" | "outline";

const useButtonTheme = (theme: ButtonTheme = "primary") => {
  const themes = {
    primary: {
      text: "text-white",
      bg: "bg-orange hover:bg-darkOrange",
      border: "border border-transparent",
    },
    secondary: {
      text: "text-white",
      bg: "bg-aqua hover:bg-darkAqua",
      border: "border border-transparent",
    },
    disabled: {
      text: "text-gray-200",
      bg: "bg-gray-300",
      border: "border border-transparent",
    },
    outline: {
      text: "text-orange",
      bg: "bg-transparent hover:bg-gray-100",
      border: "border border-orange",
    },
  };

  const selectedTheme = useMemo(() => {
    return themes[theme];
  }, [theme, themes]);

  return selectedTheme;
};

export default useButtonTheme;
